import createRestfulModule from './restful-module'
import { actionClient } from '@/api'

export default createRestfulModule({

    state: {
        collection: {
            collection: [],
            pagination: { total: 0 }
        },
        path: 'on-sale-order', // 资源路径
    },
    getters: {
        collection: state => state.collection.collection,
        pagination: state => state.collection.pagination,
        total: state => state.collection.pagination.total
    },
    actions: {
        async collection({ state, commit }, query = {}) {
            query.limit = query.limit ? query.limit : 20
            query.page = query.currentPage ? query.currentPage : 1
            const data = await actionClient.get(state.path, {
                query: {...query }
            })
            console.log(data)
            commit('setCollection', data)
        },

        async changeRefundOrderStatus({ }, { id, status }) {
            await actionClient.update(`change-refund-order-status/${id}`, {
                status
            })
        },

        async addRefundOrder({ }, data) {
            return await actionClient.post('on-sale-order', data)
        }

    }

})
